import React, {useState} from 'react';
import {Grid, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useQueryClient} from "react-query";
import useCustomers from "./useCustomers";
import Loading from "../../../../components/Site/Loading/Loading";
import LazyLoading from "../../../../components/Admin/LazyLoading/LazyLoading";
import {addNewCustomerApi} from "../../../../api/AdminApi";
import {useImageBrowser} from "../../../../hoc/useImageBrowser";
import ModalDeleteCustomer from "./modal/ModalDeleteCustomer";
import GalleryCustomer from "../../../../components/Admin/GalleryCustomer/GalleryCustomer";


const DashboardCustomers = () => {
    const client = useQueryClient();
    const queryKey = 'customer_list';
    const invalidateData = async () => {
        await client.invalidateQueries(queryKey);
    }

    const {data: customers, isLoading, hasNextPage, fetchNextPage} = useCustomers(queryKey)


    const addCustomerItem = async (file) => {
        try {
            await addNewCustomerApi({name: 'imageGallery', image: file})
            invalidateData();

        } catch (e) {
            // log error
        }

    }

    const [imageBrowser] = useImageBrowser(async (result) => {
        await addCustomerItem({...result}.blobFile);
    },false)
    return (

        <Grid sx={{flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%'}} container>
            {/*Content Header*/}

            <Grid sx={{width: "100%", alignItems: 'center', display: 'flex', justifyContent: 'space-between', mt: 3}}>
                <Typography variant="h6" component="h2"
                            sx={{fontWeight: '600', lineHeight: "38px"}}>
                    مشتری ها
                </Typography>

                <AddCircleOutlineIcon sx={{color: '#592EA9', cursor: "pointer"}}
                                      onClick={() => imageBrowser.browseForFile()}/>
                {imageBrowser.components}
            </Grid>

            <Divider sx={{
                width: '100%',
                mb: 4,
                mt: 2,
                height: '2px',
                backgroundColor: 'rgb(89, 46, 169)',
                boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
            }}/>

            <Grid container sx={{
                display: 'flex',
                width: '70%',
                flexDirection: {xs: 'column', sm: 'column', md: 'row'},
                alignItems: 'center'
            }}>


                <LazyLoading loadingTxt={'loading...'} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage}
                             maxHeight={'100%'} width={'100%'}>

                    {/*{isLoading && <CustomerTabSkeleton/>}*/}
                    {isLoading && <Loading/>}
                    {
                        customers?.pages?.map((pageResult, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {
                                        pageResult?.result?.map((customer, index) =>
                                            <React.Fragment key={index}>
                                                <GalleryCustomer item={customer} invalidateData={invalidateData}/>
                                            </React.Fragment>
                                        )
                                    }
                                </React.Fragment>
                            )
                        })
                    }

                </LazyLoading>

            </Grid>

            {/*<Grid sx={{*/}
            {/*    alignItems: "center", justifyContent: 'center',*/}
            {/*    border: {md: '1px solid #e5e0e01a', xs: 0},*/}
            {/*    m: {md: 5, xs: 2},*/}
            {/*    p: {md: 3, xs: 2},*/}
            {/*    height: "90%"*/}
            {/*}}>*/}
            {/*    <Button sx={{*/}
            {/*        background: "#592EA9",*/}
            {/*        padding: {sm: '10px 52px', xs: '10px 52px', md: '15px 100px'},*/}
            {/*        borderRadius: "30px",*/}
            {/*        marginBottom: 2*/}
            {/*    }}*/}
            {/*            variant={"contained"}>ثبت*/}
            {/*        تغییرات</Button>*/}

            {/*</Grid>*/}


        </Grid>
    )
        ;
};

export default DashboardCustomers;